
import { Options, Vue } from 'vue-class-component';
import NavBar from './components/navbar.vue'
import Footer from './components/footer.vue'
import { ParseJwt } from '@/util'
import Cookies from 'js-cookie'
import { 
  APIClient,
  Role
} from '@/components/api'; // @ is an alias to /src

@Options({
  components: {
    NavBar,
    Footer,
  },
})
export default class App extends Vue {
  
  loggedIn = false
  showPrompt = false
  ready = false
  sessionTimeout = parseInt(process.env.VUE_APP_TIMEOUT ? process.env.VUE_APP_TIMEOUT : "600" )

  mounted(){

    this.LoadData()  
  }

  onidle() {

    const settings = process.env.NODE_ENV == 'development' ? {} : {
      domain : process.env.VUE_APP_DOMAIN
    };

    Cookies.remove("API_TOKEN", settings)
    Cookies.remove("REFRESH_TOKEN", settings)
    window["location"] = "/" as any
    alert('You have been logged out');
  }

  onremind(time : any) {
      // alert seconds remaining to 00:00
      this.showPrompt = true
  }


  public async setCheckerStatus(user_info : any, client : APIClient) {

    let checker = user_info.name == "admin" || false

    try {
			
			const response = await client.get('/me')

			const services = response.data.services

      for (let i = services.length - 1; i >= 0; i--) {
        const serv = services[i]
        const anyChecker = serv.roles?.filter((el : Role) => {
          return el.sub_roles.indexOf("checker") !== -1
        })

        if (anyChecker.length){
          checker = true
          break
        }
      }

      this.$store.dispatch('updateCheckerStatus', checker)

		} catch(e){
			console.error(e)
			
		}
    
  }

  public async LoadData() : Promise<void> {


    let token = Cookies.get('API_TOKEN')

    if (!token){
      return 
    }

    this.loggedIn = true

    let user_info = ParseJwt(token)

    
    let client = new APIClient({
      "X-TOKEN" : token
    })
    
    const ctoken = await client.get("/get_ctoken")

		client = new APIClient({
			"X-CSRF-TOKEN" : ctoken.data.token,
      "X-TOKEN" : token,
		})

    if(user_info.redirect.length > 0){
      alert("Please update your password")
      this.$router.push(user_info.redirect)
    }

    let last_login = (new Date(user_info.last_updated_at)).toLocaleString()
 
    this.setCheckerStatus(user_info, client)

    this.$store.dispatch('updateLastLogin', last_login)
    
    this.$store.dispatch('updateToken', {
      "X-CSRF-TOKEN":  ctoken.data.token,
    })

    this.$store.dispatch('updateUsername', user_info.name)
    this.$store.dispatch('updateServices', user_info.services)

    // Store api client to make it reachable by
    // other pages.
    this.$store.dispatch('updateClient', client)
  }
}
